<template>
  <b-link v-ripple class="button-back" @click="onClick" />
</template>

<script>
export default {
  name: "AppButtonBack",
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-back {
  left: 0;
  width: 1.25rem;
  height: 1.25rem;
  display: block;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 0.875rem;
    height: 0.875rem;
    border: solid #fff;
    border-width: 2px 0 0 2px;
    border-radius: 2px;
    transform: rotate(-45deg);
  }
}
</style>
